/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Phoenix | v1
 * OpenAPI spec version: 1.0.0
 */

export type ExpirySeverity = typeof ExpirySeverity[keyof typeof ExpirySeverity];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ExpirySeverity = {
  None: 'None',
  Warning: 'Warning',
  Expired: 'Expired',
} as const;
